export const IconDefinitions = () => {
  return(
    <svg id="definitions-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" className="w-6 h-6">
      <circle id="Ellipse_932" data-name="Ellipse 932" cx="12.5" cy="12.5" r="12.5" fill="currentColor"/>
      <path id="Icon_material-lightbulb-outline" data-name="Icon material-lightbulb-outline" d="M10.761,18.489a.818.818,0,0,0,.815.815h3.261a.818.818,0,0,0,.815-.815v-.815H10.761ZM13.207,3A5.7,5.7,0,0,0,9.946,13.386v1.842a.818.818,0,0,0,.815.815h4.891a.818.818,0,0,0,.815-.815V13.386A5.7,5.7,0,0,0,13.207,3Zm2.323,9.049-.693.489v1.875H11.576V12.538l-.693-.489a4.076,4.076,0,1,1,4.647,0Z" transform="translate(-0.707 1.348)" fill="#fff"/>
    </svg>
  
  )
};